import React from "react";

const CareersPage = () => {
  return (
    <div className="career-container">
      <h1>Careers Page</h1>
    </div>
  );
};

export default CareersPage;
